module.exports = __webpack_public_path__ + "static/media/covid.2ee9b718.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/cat/covid.png
// module id = 110
// module chunks = 0